import React from "react";
import { IMdaeToastProps } from "./index";
import Toast from "devextreme-react/toast";
import { useDispatch } from "react-redux";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { toastDefaultConfig } from "./index";
const MdaeToast: React.FC<IMdaeToastProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Toast
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TOAST,
            e.component,
            dispatch
          );
        }}
        position={toastDefaultConfig.position}
        displayTime={
          props.displayTime ? props.displayTime : toastDefaultConfig.displayTime
        }
      ></Toast>
    </div>
  );
};
export default MdaeToast;
